module.exports = __webpack_public_path__ + "static/img/map.b9c5630.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/map.png
// module id = EoJS
// module chunks = 1